import { render, staticRenderFns } from "./BtnSearch.vue?vue&type=template&id=b68c0b36&scoped=true&"
import script from "./BtnSearch.vue?vue&type=script&lang=js&"
export * from "./BtnSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68c0b36",
  null
  
)

export default component.exports